import { GeneralModel } from "./general.model";

export class ModulePage extends GeneralModel {
    url: string;
    backColor: string;
    icon: string;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/modulePage.model.ts